import { normalizePixKey, resolvePixKeyType } from "@/shared/utils/pixKey";

import type { NewPaymentFormFullData } from "../types/new-payment.types";

export function buildFormDataForPayment(data: NewPaymentFormFullData): FormData {
  const { common, methodFields, client_id: payerClientId, organization_id: payerOrganizationId } = data;
  const formData = new FormData();
  const amount = parseFloat(String(common.monto).replace(/,/g, ".")) || 0;
  formData.append("amount", String(amount));
  formData.append("bank", common.banco);
  formData.append("client_name", common.cliente);
  formData.append("currency", common.tipoMoneda);
  formData.append("payer_name", common.nombrePagador);
  formData.append("payment_date", common.fecha);
  if (common.comprobante) {
    formData.append("attachment", common.comprobante, common.comprobante.name);
  }
  const bankMetadata: Record<string, string> = { ...methodFields };
  // BRL|Pix: the form stores the MASKED display value (PaymentMethodFieldsSection formats while typing —
  // CPF "000.000.000-00", phone "(11) 98765-4321"), but the backend always received the raw key before the
  // masking existed. Normalize back (digits / lowercase) so the data contract stays unchanged.
  if (bankMetadata.pix_key) {
    const pixType = resolvePixKeyType(bankMetadata.pix_type);
    if (pixType) bankMetadata.pix_key = normalizePixKey(pixType, bankMetadata.pix_key);
  }
  formData.append("bank_metadata", JSON.stringify(bankMetadata));
  if (common.nota?.trim()) {
    formData.append("notes", common.nota.trim());
  }
  const orgId = payerOrganizationId?.trim();
  const clientId = payerClientId?.trim();
  if (orgId) {
    formData.append("organization_id", orgId);
  } else if (clientId) {
    formData.append("client_id", clientId);
  }
  return formData;
}
